<template>
  <UiExpandedBlock
    v-model="isOpen"
    class="py-3 max-md:px-4 border-y border-y-white"
    :class="[{ 'max-md:bg-off-white-10': isOpen }]"
  >
    <template #activator="{ attrs }">
      <button
        class="flex w-full items-center ui-text-xs justify-between text-white"
        v-bind="attrs"
      >
        <p class="text-xs capitalize font-medium">{{ title }}</p>
        <div class="flex items-center gap-1">
          <UiLazyImg
            v-if="selectedItem"
            class="size-5 overflow-hidden rounded-full object-contain group-disabled:opacity-50"
            :src="
              getImageByPosition(selectedItem.medias, 'list')?.file?.url ||
              '/images/no-image.webp'
            "
            :alt="
              getImageByPosition(selectedItem.medias, 'list')?.file?.alt || ''
            "
          />
          <UiIcon
            name="chevron_up"
            class="w-6 transition"
            :class="[isOpen ? '' : 'rotate-180']"
          />
        </div>
      </button>
    </template>
    <template #content>
      <slot>
        <div
          v-if="content"
          class="ui-text-xs leading-6 text-white"
          v-html="content"
        />
      </slot>
    </template>
  </UiExpandedBlock>
</template>

<script setup lang="ts">
import { MaterialData } from "ecom-types";

const props = defineProps<{
  title: string;
  open?: boolean;
  content?: string;
  selectedItem?: MaterialData | null;
}>();

const isOpen = ref(props.open);
</script>
